import { UserType } from 'gcs-common/slices/administration/administrationUsers/administrationUsersConstants';
import { MESSAGE_TYPE } from '../../../constants/MessageTypes';
import setChannelMessagesConsumed from '../../channel/channelThunks/setChannelMessagesConsumed';
import { getCurrentUser } from '../../currentUser/currentUserSelectors';
import { channelMessagesUpsert } from '../messagesSlice';

const addMessages =
  ({ channelMessages: channelMessagesToAdd }) =>
  async (dispatch, getState) => {
    const channelIds = [...Object.keys(channelMessagesToAdd)];
    channelIds.map(async (channelId) => {
      let messagesToAdd = channelMessagesToAdd[channelId];
      const newestMessageToAdd = messagesToAdd[messagesToAdd.length - 1];

      const { authorId: newestMessageToAddAuthor } = newestMessageToAdd;
      const currentUser = getCurrentUser(getState());

      // do not add mark_read messages for craftsmen coming via pusher event
      // not needed once we migrate fully to react-query
      if (currentUser.userType === UserType.CRAFTSMAN) {
        messagesToAdd = messagesToAdd.filter((message) => message.messageType !== MESSAGE_TYPE.MARK_READ);
      }

      await dispatch(channelMessagesUpsert({ channelMessages: { [channelId]: messagesToAdd } }));

      if (
        newestMessageToAddAuthor === currentUser.id &&
        newestMessageToAdd?.messageType !== MESSAGE_TYPE.CRAFTSMAN_NOTIFICATION &&
        newestMessageToAdd?.autogenerated !== true
      ) {
        dispatch(setChannelMessagesConsumed({ channelId }));
      }
    });
  };

export default addMessages;
